import { render, staticRenderFns } from "./DlgArticleDelete.vue?vue&type=template&id=6393e40a&scoped=true&"
import script from "./DlgArticleDelete.vue?vue&type=script&lang=js&"
export * from "./DlgArticleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6393e40a",
  null
  
)

export default component.exports